import * as React from "react"
import {Input} from "@/components/ui/input"
import {Label} from "@/components/ui/label"
import {SearchRAGOperator} from "@/model/Workflow";
import {OperatorDetailProps} from "@/view/workflow/components/operatorForm/index";
import _ from "lodash";

interface SearchRAGOperatorFormProps extends OperatorDetailProps {
    operator: SearchRAGOperator
}

const SearchRAGOperatorForm: React.FC<SearchRAGOperatorFormProps> = ({operator, readOnly = false}) => {
    const onChangeSize = _.debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        operator.size = e.target.value ? Number(e.target.value) : 0;
    }, 300);

    const onChangeMrcAnswerThreshold = _.debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        operator.mrcAnswerThreshold = e.target.value ? Number(e.target.value) : 0;
    }, 300);

    const onChangeMrcThreshold = _.debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        operator.mrcThreshold = e.target.value ? Number(e.target.value) : 0;
    }, 300);

    const onChangeFaqThreshold = _.debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        operator.faqThreshold = e.target.value ? Number(e.target.value) : 0;
    }, 300);

    return (
        <div className="flex h-full flex-col space-y-4">
            <Label htmlFor="search-rag-config">Config</Label>
            <div className="flex w-full flex-col space-y-4 overflow-hidden rounded-xl border bg-card p-3 text-card-foreground shadow">
                <div className="flex flex-col space-y-1.5">
                    <Label htmlFor="search-rag-size">Passage Size</Label>
                    <Input
                        id="search-rag-size"
                        type="number"
                        defaultValue={operator.size}
                        disabled={readOnly}
                        onChange={onChangeSize}
                    />
                </div>
                <div className="flex flex-col space-y-1.5">
                    <Label htmlFor="search-rag-mrc-answer-threshold">MRC Answer Threshold</Label>
                    <Input
                        id="search-rag-mrc-answer-threshold"
                        type="number"
                        defaultValue={operator.mrcAnswerThreshold}
                        disabled={readOnly}
                        onChange={onChangeMrcAnswerThreshold}
                    />
                </div>
                <div className="flex flex-col space-y-1.5">
                    <Label htmlFor="search-rag-mrc-threshold">MRC Threshold</Label>
                    <Input
                        id="search-rag-mrc-threshold"
                        type="number"
                        defaultValue={operator.mrcThreshold}
                        disabled={readOnly}
                        onChange={onChangeMrcThreshold}
                    />
                </div>
                <div className="flex flex-col space-y-1.5">
                    <Label htmlFor="search-rag-faq-threshold">FAQ Threshold</Label>
                    <Input
                        id="search-rag-faq-threshold"
                        type="number"
                        defaultValue={operator.faqThreshold}
                        disabled={readOnly}
                        onChange={onChangeFaqThreshold}
                    />
                </div>
            </div>
        </div>
    );
};

export default SearchRAGOperatorForm;
